
import { Options, Vue } from "vue-class-component";
import ApiService from "./script/ApiService";
import { useStore } from "./store/index";
import { QueList, ContentsMaker, Contents } from "./script/QueryParser";
import Header from "./components/Side/Header.vue";
import Footer from "./components/Side/Footer.vue";
import DepartureOrderTable from "./components/Contents/DepartureOrderTable.vue";
import Stop from "./components/Contents/Stop.vue";
import ArrivalOrderTable from "./components/Contents/ArrivalOrderTable.vue";
import { Constants } from "./script/constants";
import TrainInfo from "./script/TrainInfomations";
import BothDirectionOrderTable from "./components/Contents/BothDirectionOrderTable.vue";

import TrainLocation from "./script/TrainLocation"
import DataGetter from "./script/DataGetter";

@Options({
  components: {
    Header,
    Footer,
    DepartureOrderTable,
    ArrivalOrderTable,
    Stop,
    BothDirectionOrderTable
  },
})
export default class App extends Vue {
  private store = useStore();
  public isError = false;
  private preLoadData!: TrainInfo[];
  private preLoad_Location!:TrainLocation;
  public noticeMessage = "";
  interval_lang = 0;
  interval_page = 0;
  interval_sub = 0;
  Constants = Constants;
  dataGetter = new DataGetter()

  isWordSetUpComplete = false;
  completedInitialize = false;

  public async initialize() {
    clearInterval(this.interval_lang);
    clearInterval(this.interval_page);
    clearInterval(this.interval_sub);
    this.store.commit("setQueData", this.createQueData(new URL(document.location.href).searchParams));
    try {
      if (!this.isWordSetUpComplete) {
        var ja = (await ApiService.getWordSet("ja")).data;
        var en = (await ApiService.getWordSet("en")).data;
        this.store.commit("resetWordSet");
        this.store.commit("setWord", ja.constant);
        this.store.commit("setWord", en.constant);
        this.isWordSetUpComplete = true;
      }
      await this.preLoad();
  
      this.nextQue();
      this.completedInitialize = true;

      var langSwitchTime = this.dataGetter.getQueList().langSwitchTime
      var pageSwitchTime = langSwitchTime * 2;
      this.interval_lang = setInterval(
        this.switchLang,
        langSwitchTime * 1000
      );
      this.interval_sub = setInterval(this.switchSubItem, 2000);
      this.interval_page = setInterval(
        this.nextQue,
        pageSwitchTime * 1000
      );
    } catch (e) {
      console.log(e);
      //定期（10秒）リロード
      setTimeout(() => {
        this.initialize();
      }, 10 * 1000);
    }
  }

  private async getDepTimeTable(direction: number, table_length = 16) {    
    var que = this.dataGetter.getQueList() 
    var data = (
      await ApiService.getDepTimeTable(que.myStationID, direction)
    ).data;

    let table: Array<TrainInfo> = new Array(0)

    for (let item of data) {          
      if (table.length == table_length) break;
      if (item.departureFlag) continue;
      if (item.stopInfo == 1 || (item.stopInfo == 2 && item.partialSuspensionFlag)) continue;
      if (!item.undecidedTimeFlag && item.delay[0] == 0 && item.departureTime <= this.dataGetter.getCurrentServerTime()) continue;      
      table.push(new TrainInfo(item));    
    }
    if(table.length != table_length){
      for(let i=table.length; i < table_length; i++){
        table.push(new TrainInfo(null))
      }
    }
    return table;
  }

  private async getArrTimeTable(index: number) {
    var que_list = this.dataGetter.getQueList()
    let data = (
      await ApiService.getArrTimeTable(
        que_list.myStationID,
        que_list.que[index].targetStaID,
        que_list.que[index].direction
      )
    ).data;
    let table: TrainInfo[] = new Array(0);
    for (let item of data) {
      if(item.stopInfo == 1) continue;
      if(item.expectation == null) continue;
      if (item.delay[0] == 0 && item.departureTime <= this.dataGetter.getCurrentServerTime()) continue;
      table.push(new TrainInfo(item));
    }
    return table;
  }

  public async preLoad() {
    var que_list = this.dataGetter.getQueList()
    var current_que_index = this.dataGetter.getQueIndex()
    var preload_index =
      current_que_index == que_list.que.length - 1 ? 0 : current_que_index + 1;
    this.preLoadData = [];
    
    var serverUnixTime = (await ApiService.getServerTime()).data.serverTime;
    var serverDateTime = new Date(serverUnixTime * 1000);
    var minTime = serverDateTime.getHours() * 60 + serverDateTime.getMinutes();
    this.store.commit("setCurrentServerTime",minTime)

    if (que_list.que[preload_index].viewType == Constants.VIEW_TYPE_DEPARTURE) {
      this.preLoadData = await this.getDepTimeTable(que_list.que[preload_index].direction);
    } else if(que_list.que[preload_index].viewType == Constants.VIEW_TYPE_BOTH_DIRECTION){
      this.preLoadData = (await this.getDepTimeTable(0,8)).concat(await this.getDepTimeTable(1,8))      
    } else {
      this.preLoadData = await this.getArrTimeTable(preload_index);
    }
    var json_data = (await ApiService.getTrainLocation()).data
    this.preLoad_Location = new TrainLocation(json_data)
  }

  public async roadServiceStatus() {
    var mes = (await ApiService.getInfomationMessage()).data.screen.message;
    this.noticeMessage = mes;
  }

  public createQueData(paramater:URLSearchParams): QueList {
    var query = paramater.get("Setting");
    if (query != null) {
      var data = new ContentsMaker().parseAllQueries(query);

      return data;
    } else {
      this.isError = true;
      return new QueList();
    }
  }

  public async nextQue() {
    this.store.commit("switchQueIndex");

    if (this.preLoadData == null) {
      this.store.commit("setTimeTable", null);
    } else {
      this.store.commit("setTimeTable", this.preLoadData);
    }
    this.store.commit("setTrainLocation", this.preLoad_Location);

    this.preLoad();
    this.roadServiceStatus();
  }

  public gettargetStaID() {
    var que_list = this.dataGetter.getQueList()
    var que_index = this.dataGetter.getQueIndex()
    if (
      que_list.que[que_index].viewType == Constants.VIEW_TYPE_ARRIVAL
    ) {
      return que_list.que[que_index].targetStaID;
    } else {
      return que_list.myStationID;
    }
  }

  public switchLang() {
    this.store.commit("switchLangId");
  }

  public switchSubItem() {
    this.store.commit("switchSubItem");
  }

  mounted() {
    this.initialize();
    setTimeout(() => {
      location.reload();
    }, 10800000);
  }

  beforeUnmount() {
    clearInterval(this.interval_lang);
    clearInterval(this.interval_page);
    clearInterval(this.interval_sub);
  }
}
